import React, { useContext, useEffect, useState } from 'react';

import JobListContext from '../../context/jobListContext';
import AppStateContext from "../../context/appStateContext";
import usePlannedFilterForm from '../../../hooks/usePlannedFilterForm';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

import FilterCheckBox from '../../../components/filterCheckBox';
import SearchTab from "../../../components/searchTab";
import FilterSection from '../../../components/filterSection';
import BuildingList from "../../../components/buildingList";
import { type, status, period } from './tabContent';

import {
  ClearBtn,
  Divider,
  FilterFormCtn,
  FilterHead,
} from './index.style';

import THEME from '../../../assets/styles/config';
import DatePicker from "../../../components/datePicker";
import FilterRadio from "../../../components/filterRadio";

const SearchTabPm: React.FC<any> = (): React.ReactElement => {
  const { openJobDetails, updateOpenJobDetails } = useContext(JobListContext);
  const { contractList, selectedCustomerId } = useContext(AppStateContext);

  const { width } = useWindowDimensions();
  const [ showSearchTab, setShowSearchTab ] = useState(!(width < THEME.layout.desktopLarge.breakpoint));

  const toggleSearchTab = () => {
    if (showSearchTab) {
      updateOpenJobDetails(true);
    } else {
      updateOpenJobDetails(false);
    }
    setShowSearchTab(!showSearchTab);
  };

  useEffect(() => {
    if (openJobDetails) {
      setShowSearchTab(false);
    }
  }, [openJobDetails]);

  const {
    buildingFilter,
    maintenanceTypeTabFilters,
    statusTabFilters,
    dateFilter,
    periodFilter,
    handleBuildingChange,
    handleMaintenanceTypeChange,
    handleStatusChange,
    handleSubmit,
    handleDateChange,
    handlePeriodChange,
    clearAllFilters,
  } = usePlannedFilterForm();

  return (
    <SearchTab submitFilter={handleSubmit} showTab={showSearchTab}>
      <FilterFormCtn>
        <FilterHead>
          <span>Search Criteria</span>
          <ClearBtn onClick={clearAllFilters}>Clear</ClearBtn>
        </FilterHead>
        <FilterSection title="DUE DATE">
          {period.map((item) => {
            return <FilterRadio
              active={periodFilter === item.periodCode}
              text={item.text}
              groupName="PeriodRadio"
              value={item.periodCode}
              onClick={handlePeriodChange}
            />
          })}
          <DatePicker dates={dateFilter} handleDateChange={handleDateChange}/>
        </FilterSection>
        <Divider/>
        <FilterSection title="MAINTENANCE TYPE">
          {type.map(item => {
            return <FilterCheckBox
              checked={maintenanceTypeTabFilters == item.value}
              text={item.text}
              value={item.value}
              onChange={handleMaintenanceTypeChange}
            />
          })}
        </FilterSection>
        <Divider />
        <FilterSection title="STATUS">
          {status.map(item => {
            return <FilterCheckBox
              checked={statusTabFilters == item.value}
              text={item.text}
              value={item.value}
              onChange={handleStatusChange}
            >
              {item.icon}
            </FilterCheckBox>
          })}
        </FilterSection>
        <Divider/>
        <FilterSection title="BUILDING">
          <BuildingList
            item={contractList[selectedCustomerId]}
            change={handleBuildingChange}
            filter={buildingFilter}/>
        </FilterSection>
      </FilterFormCtn>
    </SearchTab>
  );
};

export default SearchTabPm;
